import { render, staticRenderFns } from "./tambahuser.vue?vue&type=template&id=22cd0666&"
import script from "./tambahuser.vue?vue&type=script&lang=js&"
export * from "./tambahuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports